// Generated by GitHub Copilot
import React, { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import SummaryMetricCard from "./SummaryMetricCard";
import styles from "./ImpactSummaryDashboard.module.css";

// Generated by GitHub Copilot - US1812367: Updated to use active/resolved statuses
const ImpactSummaryDashboard = ({ impacts, onStatusClick, selectedStatus }) => {
  // Calculate comprehensive metrics from impacts array
  const metrics = useMemo(() => {
    const summary = {
      total: impacts.length,
      byStatus: {
        active: 0,
        resolved: 0,
      },

      uniqueBrands: new Set(),
      uniqueApplications: new Set(),
    };

    impacts.forEach((impact) => {
      // Count by status
      if (summary.byStatus.hasOwnProperty(impact.status)) {
        summary.byStatus[impact.status]++;
      }

      // Track unique brands and applications
      if (impact.brand) {
        summary.uniqueBrands.add(impact.brand);
      }
      if (impact.applicationName) {
        summary.uniqueApplications.add(impact.applicationName);
      }
    });

    return {
      ...summary,
      brandCount: summary.uniqueBrands.size,
      applicationCount: summary.uniqueApplications.size,
    };
  }, [impacts]);

  if (impacts.length === 0) {
    return null; // Don't show dashboard if no impacts
  }

  return (
    <div className={styles.dashboard}>
      {/* Primary Metrics Row - Total and Status Breakdown */}
      <Row className="g-3 mb-3">
        <Col xs={6} sm={4} md={3}>
          <SummaryMetricCard
            title="Total"
            value={metrics.total}
            variant="primary"
            size="md"
            onClick={onStatusClick}
            isClickable={!!onStatusClick}
            isSelected={selectedStatus === "Total"}
          />
        </Col>
        {/* Generated by GitHub Copilot - US1812367: Updated to Active/Resolved statuses */}
        <Col xs={6} sm={4} md={3}>
          <SummaryMetricCard
            title="Active"
            value={metrics.byStatus.active}
            icon="🔴"
            variant="danger"
            size="md"
            onClick={onStatusClick}
            isClickable={!!onStatusClick}
            isSelected={selectedStatus === "Active"}
          />
        </Col>
        <Col xs={6} sm={4} md={3}>
          <SummaryMetricCard
            title="Resolved"
            value={metrics.byStatus.resolved}
            icon="🟢"
            variant="success"
            size="md"
            onClick={onStatusClick}
            isClickable={!!onStatusClick}
            isSelected={selectedStatus === "Resolved"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ImpactSummaryDashboard;
